import React from 'react';
import { FaClock } from 'react-icons/fa';

export default function OpeningHours() {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <FaClock className="w-5 h-5" />
        Åbningstider
      </h3>
      <ul className="space-y-2">
        <li>Mandag – Fredag: 10:30 – 17:00</li>
        <li>Lørdag: Lukket</li>
        <li>Søndag og helligdage: Lukket</li>
      </ul>
    </div>
  );
}